import { render } from "./etSysDict.vue?vue&type=template&id=6f8aa2d9"
import script from "./etSysDict.vue?vue&type=script&lang=js"
export * from "./etSysDict.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__